// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MyTasksTestQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TaskFilter>;
  order?: Types.InputMaybe<Types.TaskOrder>;
}>;


export type MyTasksTestQuery = { __typename?: 'Query', tasks2: { __typename?: 'TaskPage', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number }, tasks: Array<{ __typename?: 'Task', id: string, name: string }> } };


export const MyTasksTestDocument = gql`
    query MyTasksTest($filter: TaskFilter, $order: TaskOrder) {
  tasks2(filter: $filter, order: $order) {
    pageInfo {
      hasNextPage
      totalCount
    }
    tasks {
      id
      name
    }
  }
}
    `;

/**
 * __useMyTasksTestQuery__
 *
 * To run a query within a React component, call `useMyTasksTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTasksTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTasksTestQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMyTasksTestQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyTasksTestQuery, MyTasksTestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyTasksTestQuery, MyTasksTestQueryVariables>(MyTasksTestDocument, options);
      }
export function useMyTasksTestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyTasksTestQuery, MyTasksTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyTasksTestQuery, MyTasksTestQueryVariables>(MyTasksTestDocument, options);
        }
// @ts-ignore
export function useMyTasksTestSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyTasksTestQuery, MyTasksTestQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyTasksTestQuery, MyTasksTestQueryVariables>;
export function useMyTasksTestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyTasksTestQuery, MyTasksTestQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyTasksTestQuery | undefined, MyTasksTestQueryVariables>;
export function useMyTasksTestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyTasksTestQuery, MyTasksTestQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyTasksTestQuery, MyTasksTestQueryVariables>(MyTasksTestDocument, options);
        }
export type MyTasksTestQueryHookResult = ReturnType<typeof useMyTasksTestQuery>;
export type MyTasksTestLazyQueryHookResult = ReturnType<typeof useMyTasksTestLazyQuery>;
export type MyTasksTestSuspenseQueryHookResult = ReturnType<typeof useMyTasksTestSuspenseQuery>;
export type MyTasksTestQueryResult = Apollo.QueryResult<MyTasksTestQuery, MyTasksTestQueryVariables>;